import { render, staticRenderFns } from "./family-references-form.vue?vue&type=template&id=33908848&"
import script from "./family-references-form.vue?vue&type=script&lang=js&"
export * from "./family-references-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports